import { useEffect } from 'react';
import {onSQFTLoadPrepareData, onSQFTLoadImport} from "../../helpers/sqftHelperUi";
import store from "../../../../store";
import sqftEventManager from "../../components/canvas/store/sqftEventManager";
import workspace from "../../components/canvas/core/workspace";
import scale from "../../components/canvas/core/controls/scale";
import $ from "jquery";

const useImportSQFTData = (visualizersLoaded) => {

  useEffect (() => {
    const state = store.getState()
    const {visualizerIsChanging} = state.serverState;
    if (visualizersLoaded.length && !visualizerIsChanging) {
      sqftEventManager.clearAll();

      workspace.init($('#workspace'));
      scale.init();

      let payload = onSQFTLoadPrepareData();
      onSQFTLoadImport(payload);
    }

  }, [visualizersLoaded]);
};

export default useImportSQFTData;
